import type {PageMigrator} from '../dataMigrationRunner'
import {type DocumentManager, pointerUtils} from '@wix/document-manager-core'
import type {DalValue} from '@wix/document-services-types'
import type {PageAPI} from '../../../page'
import _ from 'lodash'
import {deepClone} from '@wix/wix-immutable-proxy'
import {DATA_TYPES} from '../../../../constants/constants'

const {getPointer} = pointerUtils

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    const {dal, extensionAPI} = documentManager
    const singleLayoutDataItemsToCheck = dal.query(
        DATA_TYPES.layout,
        (extensionAPI.page as PageAPI).getPageIndexId(pageId),
        comp => comp?.type === 'SingleLayoutData'
    )
    _.forEach(singleLayoutDataItemsToCheck, (item: DalValue) => {
        if (
            !_.has(item, ['itemLayout', 'metaData']) &&
            !_.has(item, ['containerLayout', 'metaData']) &&
            !_.has(item, ['componentLayout', 'metaData'])
        ) {
            return
        }
        const _item = deepClone(item)
        if (_.has(_item, ['itemLayout', 'metaData'])) {
            delete _item.itemLayout.metaData
        }
        if (_.has(_item, ['containerLayout', 'metaData'])) {
            delete _item.containerLayout.metaData
        }
        if (_.has(_item, ['componentLayout', 'metaData'])) {
            delete _item.componentLayout.metaData
        }
        dal.set(getPointer(item.id, DATA_TYPES.layout), _item)
    })
}

export const fixSingleLayoutData: PageMigrator = {
    migratePage,
    name: 'fixSingleLayoutData',
    version: 1
}
